import React, { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import Button from "../global/Button";
import Input from "../global/Input";
import CheckBox from "../global/CheckBox";
import { useNavigate, useParams } from "react-router-dom";
import { useEditClubMutation } from "../../lib/redux/services/sections/Clubs";
import { useCreateServiceMutation } from "../../lib/redux/services/sections/Services";
import { toast } from "react-toastify";
import { toastMessage } from "../../utils/utils";
import ValidateError from "../global/ValidateError";
import { useGetDictionary } from "../../hooks/useGetDictionary";
import { DictionaryType } from "../../types";
import { CURRENCY } from "../../constants";

type FormInput = {
  name: string;
  price: number;
};

const ClubInfoForm2 = () => {
  const { Auth, inputs }: DictionaryType = useGetDictionary();
  const navigate = useNavigate();
  const { club_id } = useParams();
  const [createService] = useCreateServiceMutation();
  const [editClub] = useEditClubMutation();
  const [serviceIds, setServiceIds] = useState<string[]>([]);

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<FormInput>();

  const handleServiceChange = (label: string, isChecked: boolean) => {
    if (isChecked) {
      setServiceIds((prev) => [...prev, label]); // Add to array
    } else {
      setServiceIds((prev) => prev.filter((service) => service !== label)); // Remove from array
    }
  };

  const onSubmit = async (formData: FormInput) => {
    try {
      const data = await toast.promise(
        createService({ data: formData, id: club_id }).unwrap(),
        toastMessage()
      );

      const ClubData = await toast.promise(
        editClub({ data: { service_ids: serviceIds }, id: club_id }).unwrap(),
        toastMessage()
      );

      navigate(`/auth/club-info-3/${club_id}`);
    } catch (error) {}
  };

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="space-y-4 md:space-y-6 max-w-[814px] px-5 py-5"
    >
      <div className="flex text-start flex-col items-center justify-center gap-6 w-full">
        {/* Checkboxes Section */}
        <div className="w-full flex flex-row justify-between flex-wrap">
          {["Ball", "Free Parking", "Water", "Store", "Food", "Beverages"].map(
            (label) => (
              <CheckBox
                key={label}
                label={label}
                checkboxProps={{
                  checked: serviceIds.includes(label), // Controlled value

                  onChange: (e:React.ChangeEvent<HTMLInputElement>) =>
                    handleServiceChange(label, e.target.checked), // Update state
                }}
              />
            )
          )}
        </div>

        {/* Name and Price Section */}
        <div className="flex text-start flex-row items-baseline justify-center gap-6 w-full">
          <div className="w-full">
            <Controller
              name="name"
              rules={{ required: true }}
              control={control}
              render={({ field }) => (
                <Input
                  inputProps={{
                    ...field,
                    type: "text",
                  }}
                  label={inputs.extra_name}
                />
              )}
            />
            {errors.name && <ValidateError />}
          </div>

          <div className="w-full">
            <Controller
              name="price"
              rules={{ required: true }}
              control={control}
              render={({ field }) => (
                <Input
                  inputProps={{
                    ...field,
                    type: "number",
                    onWheel: (e) => {
                      e.preventDefault();
                      //@ts-ignore
                      e.target.blur();
                    },
                  }}
                  label={inputs.price}
                  title={CURRENCY()}
                />
              )}
            />
            {errors.price && <ValidateError />}
          </div>
        </div>
      </div>
      <div className="flex flex-row justify-center items-center pt-4 gap-10">
        <Button
          customeStyle="bg-white text-primary dark:text-white  w-full rounded-full  text-base py-2.5 border-primary border-2"
          href="/auth/register"
          text="Back"
          width="max-w-[400px] w-full"
        />
        <Button
          customeStyle="bg-primary text-white w-full rounded-full text-base py-2.5 border-primary border-2"
          text="Save And Next"
          width="max-w-[400px] w-full"
          type="submit"
        />
      </div>
    </form>
  );
};

export default ClubInfoForm2;
